/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Disable BBook request.
 */
export interface DisableBBookRequest {
  /**
   * Try to close positions
   */
  closePositions: boolean;
}
